module.exports = __webpack_public_path__ + "assets/img/ropeway.1dc72402.png";